var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("md-card-content", { staticClass: "body-list" }, [
        !_vm.isListLoading
          ? _c("div", [
              _vm.levyRatelist != null && _vm.levyRatelist.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "header-button-container add-button" },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary md-just-icon md-round",
                              attrs: { title: "Add New Rate" },
                              on: {
                                click: function ($event) {
                                  return _vm.createNewRate()
                                },
                              },
                            },
                            [_c("md-icon", [_vm._v("note_add")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "md-table",
                        { staticClass: "custom-paginated-table" },
                        [
                          _c(
                            "draggable",
                            {
                              staticClass: "custom-draggable",
                              attrs: { draggable: ".drag-item" },
                              on: {
                                change: function ($event) {
                                  return _vm.rateListChanged(
                                    _vm.levyRatelist.item
                                  )
                                },
                                end: function ($event) {
                                  return _vm.onEnd(_vm.levyRatelist)
                                },
                              },
                              model: {
                                value: _vm.levyRatelist,
                                callback: function ($$v) {
                                  _vm.levyRatelist = $$v
                                },
                                expression: "levyRatelist",
                              },
                            },
                            [
                              _c(
                                "md-table-row",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c("md-table-head", {
                                    staticClass: "drag-icon",
                                  }),
                                  _c("md-table-head", {
                                    staticClass: "override-icon",
                                  }),
                                  _c("md-table-head", [_vm._v("Fuel Levy")]),
                                  _c("md-table-head", [
                                    _vm._v("Futile Charge"),
                                  ]),
                                  _vm.driverRuleCreation
                                    ? _c("md-table-head", [
                                        _vm._v(
                                          "\n                                Commission\n                            "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c("md-table-head", [_vm._v("Availability")]),
                                  _c("md-table-head", [
                                    _vm._v("Include Surcharge"),
                                  ]),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "action-class" },
                                    [_vm._v("Actions")]
                                  ),
                                ],
                                1
                              ),
                              _vm._l(_vm.levyRatelist, function (item) {
                                return _c(
                                  "md-table-row",
                                  {
                                    key: item.rateRulesId,
                                    class:
                                      _vm.rateGroupIdHighlight ===
                                      item.rateRulesId
                                        ? "drag-item highlight-row"
                                        : "drag-item",
                                  },
                                  [
                                    _c(
                                      "md-table-cell",
                                      { staticClass: "drag-icon" },
                                      [
                                        _c("md-icon", [
                                          _vm._v(
                                            "\n                                    drag_indicator\n                                "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { staticClass: "override-icon" },
                                      [
                                        item.overrideRule
                                          ? _c(
                                              "md-icon",
                                              [
                                                _vm._v(
                                                  "\n                                    priority_high\n                                    "
                                                ),
                                                _c("md-tooltip", [
                                                  _vm._v("Override Rule"),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c("md-table-cell", [
                                      item.fuelLevyPercentage !== null
                                        ? _c("div", [
                                            item.fuelLevyPercentage.operator !==
                                            "="
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        item.fuelLevyPercentage
                                                          .operator
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.formatPercentage(
                                                    item.fuelLevyPercentage
                                                      .value
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ])
                                        : _c("div", [_c("br")]),
                                      item.condition !== null &&
                                      !_vm.hideConditionRules
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "condition-container",
                                            },
                                            [
                                              _c(
                                                "md-table-cell",
                                                {
                                                  staticStyle: {
                                                    display: "contents",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "md-chips",
                                                    {
                                                      staticClass:
                                                        "md-primary condition-block",
                                                      attrs: {
                                                        "md-static": "",
                                                      },
                                                    },
                                                    [
                                                      _vm._l(
                                                        item.condition,
                                                        function (
                                                          oper,
                                                          conditionIndex
                                                        ) {
                                                          return [
                                                            _vm.checkForOperatorData(
                                                              oper
                                                            )
                                                              ? _c(
                                                                  "md-chip",
                                                                  {
                                                                    key: conditionIndex,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                    " +
                                                                        _vm._s(
                                                                          _vm.formatOperatorData(
                                                                            oper
                                                                          )
                                                                        ) +
                                                                        "\n                                                "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "md-chip",
                                                              {
                                                                key:
                                                                  conditionIndex +
                                                                  "-op",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      _vm.formatConditionData(
                                                                        oper
                                                                      )
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c("md-table-cell", [
                                      item.futileCharge !== null
                                        ? _c("div", [
                                            item.futileCharge.operator !== "="
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        item.futileCharge
                                                          .operator
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    item.futileCharge.value,
                                                    item.currency
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _vm.driverRuleCreation
                                      ? _c("md-table-cell", [
                                          item.driverCommission !== null
                                            ? _c("div", [
                                                item.driverCommission
                                                  .operator !== "="
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            item
                                                              .driverCommission
                                                              .operator
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.formatPercentage(
                                                        item.driverCommission
                                                          .value
                                                      )
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "md-table-cell",
                                      [
                                        _c("selected-day", {
                                          attrs: { rule: item },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("md-table-cell", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.formatIncludeSurcharge(
                                              item.fuelLevyIncludesAllCharges
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]),
                                    _c(
                                      "md-table-cell",
                                      { staticClass: "action-buttons" },
                                      [
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-warning md-just-icon md-round",
                                            attrs: {
                                              title: "Update rate details",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.updateRate(
                                                  item.rateRulesId
                                                )
                                              },
                                            },
                                          },
                                          [_c("md-icon", [_vm._v("edit")])],
                                          1
                                        ),
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-danger md-just-icon md-round",
                                            attrs: { title: "Delete rule" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.validateDeleteRate(
                                                  item.rateRulesId
                                                )
                                              },
                                            },
                                          },
                                          [_c("md-icon", [_vm._v("delete")])],
                                          1
                                        ),
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-success md-just-icon md-round",
                                            attrs: { title: "Add Condition" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.openCreateCondition(
                                                  item.rateRulesId
                                                )
                                              },
                                            },
                                          },
                                          [_c("md-icon", [_vm._v("rule")])],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm.levyRatelist.length > 0
                        ? _c(
                            "md-card-actions",
                            {
                              staticClass: "page-footer",
                              attrs: { "md-alignment": "space-between" },
                            },
                            [
                              _c("div", [
                                _vm.total === _vm.pagination.perPage
                                  ? _c("p", { staticClass: "card-category" }, [
                                      _vm._v(
                                        "\n                            Page " +
                                          _vm._s(_vm.pagination.currentPage) +
                                          " of many\n                        "
                                      ),
                                    ])
                                  : _c("p", { staticClass: "card-category" }, [
                                      _vm._v(
                                        "Page " +
                                          _vm._s(_vm.pagination.currentPage) +
                                          " of " +
                                          _vm._s(_vm.maxPage)
                                      ),
                                    ]),
                              ]),
                              _c("pagination", {
                                staticClass:
                                  "pagination-no-border pagination-success",
                                attrs: {
                                  "per-page": _vm.pagination.perPage,
                                  total: _vm.total,
                                },
                                on: {
                                  "change-page": function ($event) {
                                    return _vm.handleChangePage(
                                      $event,
                                      _vm.pagination.perPage
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.pagination.currentPage,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pagination, "currentPage", $$v)
                                  },
                                  expression: "pagination.currentPage",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.levyRatelist.length == 0 && !_vm.isListLoading
                ? _c("div", { staticClass: "text-center" }, [
                    _c("p", { staticClass: "no-result-message" }, [
                      _vm._v("No Rates Created"),
                    ]),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "custom-btn",
                          on: { click: _vm.createNewRate },
                        },
                        [
                          _vm._v(
                            "\n                        Add New Rule\n                    "
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ])
          : _c("div", { staticClass: "body-list" }, [
              _c(
                "div",
                { staticClass: "content-loader" },
                [
                  _c("fade-loader", {
                    attrs: { loading: _vm.isListLoading, color: "#333333" },
                  }),
                  _c("span", [_vm._v("LOADING")]),
                ],
                1
              ),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }